import React, { useState } from 'react';
import { observer } from 'mobx-react';
import styles from './ReviewsFilters.module.css';
import { ReviewListParams } from '../../../api/reviews/dto/ReviewListParams.dto';
import { Button } from '../../../components/UI/Button/Button';
import { Input } from '../../../components/UI/input/input';

interface ReviewsFiltersProps {
  filters: ReviewListParams;
  onFiltersChange: (filters: Partial<ReviewListParams>) => void;
  loading?: boolean;
}

export const ReviewsFilters: React.FC<ReviewsFiltersProps> = observer(
  ({ filters, onFiltersChange, loading = false }) => {
    const [localFilters, setLocalFilters] = useState({
      search: filters.search || '',
      sort_by: filters.sort_by || 'created_at',
      sort_order: filters.sort_order || 'desc',
    });

    // Применение фильтров
    const handleApplyFilters = () => {
      const newFilters: Partial<ReviewListParams> = {};

      if (localFilters.search) {
        newFilters.search = localFilters.search;
      }

      newFilters.sort_by = localFilters.sort_by;
      newFilters.sort_order = localFilters.sort_order;

      onFiltersChange(newFilters);
    };

    // Сброс фильтров
    const handleResetFilters = () => {
      const resetFilters = {
        search: '',
        sort_by: 'created_at' as const,
        sort_order: 'desc' as const,
      };

      setLocalFilters(resetFilters);
      onFiltersChange({
        sort_by: 'created_at',
        sort_order: 'desc',
      });
    };

    return (
      <div className={styles.container}>
        <div className={styles.filtersGrid}>
          <div className={styles.filterGroup}>
            <label className={styles.label}>Поиск</label>
            <Input
              value={localFilters.search}
              onChange={(e) =>
                setLocalFilters((prev) => ({ ...prev, search: e.target.value }))
              }
              placeholder="Поиск по тексту отзыва..."
              disabled={loading}
            />
          </div>

          <div className={styles.filterGroup}>
            <label className={styles.label}>Сортировка</label>
            <select
              className={styles.select}
              value={localFilters.sort_by}
              onChange={(e) => {
                const value = e.target.value as ReviewListParams['sort_by'];
                if (value) {
                  setLocalFilters((prev) => ({ ...prev, sort_by: value }));
                }
              }}
              disabled={loading}
            >
              <option value="created_at">По дате создания</option>
              <option value="updated_at">По дате изменения</option>
              <option value="published_at">По дате публикации</option>
              <option value="rating">По рейтингу</option>
            </select>
          </div>

          <div className={styles.filterGroup}>
            <label className={styles.label}>Направление</label>
            <select
              className={styles.select}
              value={localFilters.sort_order}
              onChange={(e) => {
                const value = e.target.value as ReviewListParams['sort_order'];
                if (value) {
                  setLocalFilters((prev) => ({ ...prev, sort_order: value }));
                }
              }}
              disabled={loading}
            >
              <option value="desc">По убыванию</option>
              <option value="asc">По возрастанию</option>
            </select>
          </div>
        </div>

        <div className={styles.actions}>
          <Button
            appearance="auth"
            onClick={handleApplyFilters}
            disabled={loading}
          >
            Применить фильтры
          </Button>
          <Button
            appearance="back"
            onClick={handleResetFilters}
            disabled={loading}
          >
            Сбросить
          </Button>
        </div>
      </div>
    );
  },
);
